module.exports = __webpack_public_path__ + "img/assign_reviewer.63f815f2.svg";